// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : timeline parts
// ---Third-party imports
import React from 'react'
import {Segment, Grid, Icon} from 'semantic-ui-react'

// ---Framework imports
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {keys} from 'ldash'
import {useSelector, useState, usePhysicalNode} from 'uix/hooks'

// ---Local imports
import {Timeline as XTimeline} from './components'

// ---Exports
export const Timeline = ({}) => {
  let node = usePhysicalNode()
  if (['metadata', 'topstructure'].includes(node.datatypeName)) {
    return <XTimeline otid={node.otid} />
  } else {
    return <XTimeline />
  }
}
